import {percentReturn} from "../../utils/math";

export const getDataPointsForAnchors = (dataSeries, xAnchor, secondXAnchor = null) => {
    const x1 = [];
    const x2 = [];
    // Helper function to convert Unix milliseconds to YYYY-MM-DD string
    const convertToDateString = (unixMs) => {
        const date = new Date(unixMs);
        return date.toISOString().split('T')[0]; // Convert to 'YYYY-MM-DD'
    };

    console.log("XAnchor: ", xAnchor)
    console.log("SecondXAnchor: ", secondXAnchor)
    // Convert xAnchor and secondXAnchor to YYYY-MM-DD strings
    const xAnchorDate = convertToDateString(xAnchor);
    const secondXAnchorDate = secondXAnchor ? convertToDateString(secondXAnchor) : null;

    dataSeries.forEach((plotConfig) => {
        plotConfig.data.forEach((seriesConfig) => {
            const data = seriesConfig.data;

            // Find the full data row for xAnchorDate
            const xAnchorPoint = data.find(point => point[0] === xAnchorDate);
            const initValue = data[0][1];
            if (xAnchorPoint) {
                x1.push({
                    seriesName: seriesConfig.name,
                    data: xAnchorPoint,
                    pct: percentReturn(xAnchorPoint[1], initValue) * 100
                });
            }

            // Find the full data row for secondXAnchorDate, if it exists
            if (secondXAnchorDate) {
                const secondXAnchorPoint = data.find(point => point[0] === secondXAnchorDate);
                if (secondXAnchorPoint) {
                    x2.push({
                        seriesName: seriesConfig.name,
                        data: secondXAnchorPoint,
                        pct: percentReturn(secondXAnchorPoint[1], initValue) * 100
                    });
                }
            }
        });
    });

    return {x1, x2}
};


export function calculateChangeFromAnchors(selectedPoints) {
    const { x1, x2 } = selectedPoints;


    if (!x2 || x1.length !== x2.length) {
        throw new Error("x2 is missing or doesn't match the structure of x1.");
    }

    const percentageReturns = [];

    x1.forEach((itemX1) => {
        const correspondingX2 = x2.find(itemX2 => itemX2.seriesName === itemX1.seriesName);

        if (correspondingX2) {
            const valueX1 = itemX1.data[1]; // Assuming the second element is the value
            const valueX2 = correspondingX2.data[1]; // Same for x2

            const decimalReturn = ((valueX2 - valueX1) / valueX1);

            percentageReturns.push({
                seriesName: itemX1.seriesName,
                percentageReturn: decimalReturn // Rounded to 2 decimal places
            });
        }
    });

    return percentageReturns;
}
